import { ShareInfoFragment, useShareRestoreMutation } from 'gqlTypes'
import { ErrorHandler } from 'modules/tracing'
import { handleShareRestored } from './handlers'

export interface UseShareRestoreProps {
  identifier: string
  onCompleted: (share: ShareInfoFragment) => void
  onError: (message: string) => void
}

export const useShareRestore = (props: UseShareRestoreProps) => {
  const { identifier, onCompleted, onError } = props

  return useShareRestoreMutation({
    redirectErrors: true,
    variables: { identifier },
    onCompleted: data => {
      if (!data?.shareRestore?.share) {
        onError('Something is wrong, please contact our support team')
        ErrorHandler.shouldNeverHappen('shareRestore')
        return
      }

      onCompleted(data.shareRestore.share)
    },
    update: cache => {
      handleShareRestored({ cache, identifier })
    },
    onError: graphqlError => {
      onError(graphqlError.message)
    },
  })
}
